import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, PRICE, PRODUCT } from '../data/content';
export function PricingSection() {
  return <section id="oferta" aria-labelledby="precio" className="bg-electric" data-id="element-106" data-mp="1eg5n6d6qwcc6">
      <div className="mx-auto max-w-page px-3 py-8 text-center sm:px-6 sm:py-10" data-id="element-107" data-mp="1j9qoae3mxmfl">
        <Reveal data-id="element-108" data-mp="1n9ioo3ivkm9v">
          <h2 id="precio" className="font-display text-xl uppercase leading-tight text-white sm:text-3xl lg:text-4xl" data-id="element-109" data-mp="1na0thojls8te">
            Oferta especial — Sistema completo 6 en 1
          </h2>
          <p className="mt-1 text-[0.85rem] font-bold text-volt sm:text-base" data-id="element-110" data-mp="1x6nbm5kjolrq">
            Comienza hoy desde cero y avanza a tu ritmo.
          </p>
        </Reveal>

        <Reveal delay={0.05} className="mx-auto mt-4 max-w-xl rounded-2xl border-2 border-volt bg-night p-4 sm:p-6" data-id="element-111" data-mp="2w0i91sygo3b">
          <h3 className="font-display text-base uppercase leading-tight text-volt sm:text-2xl" data-id="element-112" data-mp="1mgoe79tuv7jt">
            ⚡ {PRODUCT}
          </h3>
          <p className="mt-1 font-display text-lg uppercase text-white sm:text-2xl" data-id="element-113" data-mp="1hpofq0538hf7">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-2 rounded-lg bg-volt/15 px-3 py-1.5 text-[0.78rem] font-extrabold uppercase text-volt sm:text-sm" data-id="element-114" data-mp="1crejrnbjhcsj">
            🎁 Bonos valorados en {BONUS_VALUE}
          </p>

          <p className="mt-3 text-[0.75rem] font-extrabold uppercase tracking-[0.18em] text-white sm:text-sm" data-id="element-115" data-mp="25e7sosz31idm">
            🔥 Oferta especial
          </p>
          <p className="text-[0.7rem] font-bold uppercase tracking-[0.24em] text-steel sm:text-xs" data-id="element-116" data-mp="1vh312dmgwupf">
            Hoy:
          </p>
          <p className="font-display text-4xl leading-none text-volt sm:text-6xl" data-id="element-117" data-mp="1repyfy30pcwv">
            {PRICE}
          </p>
          <p className="mt-1 text-[0.7rem] font-semibold uppercase tracking-wide text-steel sm:text-xs" data-id="element-118" data-mp="k3r66s8ormfe">
            Pago único • Sin mensualidades • Acceso Digital
          </p>

          <div className="mt-4 flex flex-col items-center gap-2" data-id="element-119" data-mp="hit7fbyau29m">
            <CtaButton href={CHECKOUT_URL} external size="lg" data-id="element-120" data-mp="mgkxe0fdveb6">
              🚀 SÍ, QUIERO EL SISTEMA COMPLETO POR {PRICE}
            </CtaButton>
            <p className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[0.7rem] font-bold uppercase tracking-wide text-steel sm:text-xs" data-id="element-121" data-mp="7j2a72ict95u">
              Acceso Inmediato
              <span aria-hidden="true" data-id="element-122" data-mp="3uvw8as15wz7n">•</span>
              <span className="flex items-center gap-1" data-id="element-123" data-mp="3uutlowavhixj">
                <ShieldCheckIcon size={13} className="text-volt" data-id="element-124" data-mp="3is4zs2dyms1" />
                Garantía de 7 Días
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}